/**
 * @description: API接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

import activity from './modules/activity';
import task from './modules/task';
import fission from './modules/fission';
import withdraw from './modules/withdraw';
import game from './modules/game';
import other from './modules/other';
import clientApi from './modules/client-api';
import membership from './modules/membership';
import mall from './modules/mall';
import aimusic from './modules/aimusic';

export default {
	// 获取弹窗配置接口
	GET_MODAL_CONF_API: '/window/windows',
	// 错误上报接口
	EXCEPTION_LOG_API: '/config/exception_log',
	// 获取激励视频公共配置数据接口
	GET_IMPRESS_VIDEO_API: '/ad/impress_for_video',
	// 获取反馈链接
	GET_FEEDBACK_LINK: '/config/getFeedbackLink',
	...activity,
	...task,
	...fission,
	...withdraw,
	...game,
	...other,
	...clientApi,
	...membership,
	...mall,
	...aimusic,
};



// WEBPACK FOOTER //
// ./src/service/api/index.js